import { Button } from '@atom/button/button';

import { Menu, Wrapper } from './main-hamburger.style';

interface MainHamburgerProps {
  isMobile: boolean;
  isMobileMenuOpen: boolean;
  onClick: () => void;
}

export const MainHamburger = ({ isMobile, isMobileMenuOpen, onClick }: MainHamburgerProps) =>
  isMobile &&
  !isMobileMenuOpen && (
    <Wrapper>
      <Button color='default' variant='link' onClick={onClick}>
        <Menu />
      </Button>
    </Wrapper>
  );
